import script from "./VatLoans.vue?vue&type=script&setup=true&lang=ts"
export * from "./VatLoans.vue?vue&type=script&setup=true&lang=ts"

import "./VatLoans.vue?vue&type=style&index=0&id=36b4d402&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b4d402"]])

export default __exports__